export const projects = [
    {
        title: 'Gemini Webpage Clone',
        desc: 'A landing page Gemini Webpage Clone where you can query the AI',
        techStack: 'Reactjs, Css3, Javascript',
        open: 'NULL',
        link: 'https://github.com/punixcorn/email-analysis',
    },
    {
        title: 'Spyhuntrs',
        desc: 'Rust Vulnerability Scanning Tool ',
        techStack: 'Rust',
        open: 'NULL',
        link: 'https://github.com/punixcorn/spyhuntrs',
    },
    {
        title: 'gitalias',
        desc: 'An implementation of git using ligit',
        techStack: 'C++, Cmake, make',
        open: 'NULL',
        link: 'https://github.com/punixcorn/gitalias-libgit',
    },
    {
        title: 'portscanner',
        desc: 'A port scanner in c++',
        techStack: 'C++,C++/C buildsystems',
        open: 'NULL',
        link: 'https://github.com/punixcorn/portscanner',
    },
    {
        title: 'C++ Webserver',
        desc: 'A webserver in C++ which implements HTTP requests',
        techStack: 'C++,C++/C buildsystems',
        open: 'NULL',
        link: 'https://github.com/punixcorn/Cpp-webserver',
    },
    {
        title: 'Email Analysis Tool',
        desc: 'A cli used to analyse emails with Gemini Ai implementation',
        techStack: 'Typescript,npm',
        open: 'NULL',
        link: 'https://github.com/punixcorn/email-analysis',
    },
    {
        title: 'Simple Usb driver',
        desc: 'a simple usb driver in linux, that outputs info about the usb',
        techStack: 'C,C buildsystems',
        open: 'NULL',
        link: 'https://github.com/punixcorn/simple-usb-driver',
    },
    {
        title: 'Fetch Reddit posts',
        desc: 'a cli application to fetch reddits posts of your choice into a json file',
        techStack: 'Typescript, Json, npm',
        open: 'NULL',
        link: 'https://github.com/punixcorn/fetchRedditPosts',
    },
];

// put links in here???
//<MdWeb />
//<FcEngineering />
//<CiMicrochip />
//<SiLinux />
export const InterestedAreas = [
    {
        id: 0,
        title: 'Web development',
        link: '',
        img: '',
    },
    {
        id: 1,
        title: 'Systems programming',
        link: '',
    },
    {
        id: 2,
        title: 'Linux/Unix like operating systems',
        link: '',
    },
    {
        id: 3,
        title: 'Reverse Engineering',
        link: '',
    },
];

export const spotlightProjects = [
    {
        title: 'Spyhuntrs',
        desc: 'A rust vulnerability scanner',
        techStack: 'Rust',
        open: '',
        link: 'https://github.com/punixcorn/spyhuntrs',
        image: require('../assets/spyhuntrs.png'),
    },
    {
        title: 'no libc',
        desc: 'An mini implementation of libc',
        techStack: 'C, C/C++buildsystems',
        open: 'https://punixcorn.github.io/no_libc/',
        link: 'https://github.com/punixcorn/no_libc',
        image: require('../assets/nolibc.png'),
    },
    {
        title: 'The Moon',
        desc: 'An image website with stuff about the moon',
        techStack: 'Reactjs,CSS3',
        open: 'https://punixcorn.github.io/the-moon',
        link: 'https://github.com/punixcorn/the-moon',
        image: require('../assets/moon-large.png'),
    },
    {
        title: 'portfolio',
        desc: 'Personal portfolio website showcasing skills and projects',
        techStack: 'Reactjs, tailwindcss, js',
        open: 'https://punixcorn.github.io/portfolio',
        link: 'https://github.com/punixcorn/protfolio',
        image: require('../assets/portfolio.png'),
    },
    {
        title: 'PotatOs',
        desc: 'a simple bootloader that boots into protected mode',
        techStack: 'C, C++, C/C++ buildsystems, Assembly',
        open: 'site for deployments',
        link: 'https://github.com/punixcorn/potatOs',
        image: require('../assets/bootloader.png'),
    },
    {
        title: 'Binfiles',
        desc: 'Linux Terminal apps to make tasks easier',
        techStack: 'C++, C, C/C++ buildsystems, bash',
        open: 'site for deployments',
        link: 'https://github.com/punixcorn/binfiles',
        image: require('../assets/binfiles.png'),
    },
    {
        title: 'Gemini Webpage Clone',
        desc: 'A landing page Gemini Webpage Clone where you can query the AI',
        techStack: 'Reactjs, Css3, Javascript',
        open: 'https://punixcorn.github.io/gemini-clone',
        link: 'https://github.com/punixcorn/email-analysis',
        image: require('../assets/gemini.png'),
    },
];
